export default "__VITE_ASSET__662a5676__"